import React, { useState } from "react"

import { faVolumeMute, faVolumeUp } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

import ChimeCloudRoom from "components/ChimeCloudroom/QualityControlLayout"

const ChimeCloudRoomContainer = ({ session, localUser }) => {
  const [muted, setMuted] = useState(true)

  const toggleMute = () => {
    setMuted(!muted)
  }

  return (
    <div
      key={session.id}
      className="aspect-[4/3] h-[20vh] overflow-hidden rounded-md border-solid border-gray-300 p-2 shadow-sm"
    >
      <h4 className="m-0 mb-1 flex items-center justify-between">
        <a
          href={session.showPath}
          target="_blank"
          rel="noopener noreferrer"
          className="overflow-hidden text-ellipsis whitespace-nowrap text-base"
        >
          {session.tutor.fullName}: {session.subject.name}
        </a>
        {session.chimeJoinInfo && (
          <button
            onClick={toggleMute}
            className="ml-2 max-h-min cursor-pointer rounded-md border-none bg-blue-400 px-2 py-1 text-lg text-white shadow-none outline-none hover:bg-blue-300"
          >
            <FontAwesomeIcon icon={muted ? faVolumeMute : faVolumeUp} />
          </button>
        )}
      </h4>
      <div>
        {session.chimeJoinInfo ? (
          <ChimeCloudRoom
            key={session.id}
            session={session}
            localUser={localUser}
            muted={muted}
          />
        ) : (
          <p className="pt-6 text-center italic">
            This cloudroom is not active.
          </p>
        )}
      </div>
    </div>
  )
}

export default ChimeCloudRoomContainer
